import { render, staticRenderFns } from "./NuevoProveedor.vue?vue&type=template&id=65ae09f3"
import script from "./NuevoProveedor.vue?vue&type=script&lang=js"
export * from "./NuevoProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports